import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SessionExpiryService } from '@pharvio/core/ui';
import { PwaInstallFloaterComponent } from './core/components/pwa-install-floater/pwa-install-floater.component';

@Component({
  selector: 'vex-root',
  templateUrl: './app.component.html',
  imports: [RouterOutlet, PwaInstallFloaterComponent]
})
export class AppComponent {
  constructor() {
    inject(SessionExpiryService).init();
  }
}
